import React, { useState } from "react";

//import stock
import stock from "../img/image1.jpg";
import stock1 from "../img/image2.jpg";
import stock2 from "../img/image3.jpg";
import stock3 from "../img/image4.jpg";
import stock4 from "../img/image5.jpg";
import stock5 from "../img/image6.jpg";

import drms1 from "../img/works/drms-1.gif";
import eton1 from "../img/works/eton-1.gif";
import raseye1 from "../img/works/raseye-1.jpeg";
import 졸작1 from "../img/works/졸작-1.png";
import dice1 from "../img/works/dice-1.jpg";

import { Button, Modal } from "react-bootstrap";
function Portfolio() {
  const modalContent = [
    {
      title: "재난대응플랫폼",
      body: {
        "프로젝트 타입": "gractor 기업협업",
        주제: "코로나 재난 대응 플랫폼으로, 실시간 데이터를 토대로 차트 분석",
        "수행 기간": "2021-02 ~ 2021-03",
        포지션: "Full-Stack, 팀장",
        사용스택: [
          "Nuxt.js",
          "Vue",
          "ElasticSearch",
          "Node.js",
          "Express",
          "Echart",
          "D3",
        ],
        깃헙링크: "https://github.com/ddubbu/gractor-DRMS",
        배포링크: false,
        역할: [
          [
            "원격 서버 접속 및 환경 구축",
            "public ip 터널링 및 포트 포워딩을 통해 사내 서버 접근",
          ],
          [
            "NoSQL data modeling",
            "RDBMS와 NoSQL의 차이를 이해하고 단순 렌더링 및 데이터 업데이트 빈도에 따라 db 설계",
          ],
          [
            "지도 시각화",
            "d3 라이브러리를 이용해 서울특별시 구단위 지도를 구현하고 click, zoom, hover 이벤트를 구현",
          ],
          [
            "실시간 데이터 시각화",
            "mqtt, websocket 을 이용해 실시간 데이터를 받고 line, bar 타입의 차트 그리고 지도 업데이트",
          ],
          [
            "로그인 및 세션 관리",
            "브라우저에서 GET 요청 시 쿠키에 저장된 세션을 토대로 로그인 상태를 갱신한다. 이를 통해 새로고침 및 같은 브라우저에서 로그인 상태 공유 이슈를 해결했다.",
          ],
          [
            "Dashboard 기능 구현 (Create, Read, Update)",
            "대시보드 생성, 각 페이지 렌더링을 위한 데이터 요청, 업무 상태 수정 등 필요한 API 작성 및 로직 처리",
          ],
        ],
        발표영상: false,
      },
    },
    {
      title: "ETON",
      body: {
        "프로젝트 타입": "3인 프로젝트",
        주제: "코로나 재난 대응 플랫폼으로, 실시간 데이터를 토대로 차트 분석",
        "수행 기간": "2021-02",
        포지션: "Front-end, 팀장",
        사용스택: [
          "ReactJS",
          "Node.js",
          "Express",
          "JWT",
          "Sequelize",
          "MySQL",
          "AWS (EC2, RDS, S3, Route53, Elastic Load Balancer)",
        ],
        깃헙링크: "https://github.com/codestates/ETON-client",
        배포링크: "https://eton-project.ga/intro",
        회고록: "https://kr-ddubbu.tistory.com/79",
        역할: [
          ["Board Page (Drag & Drop 기능 구현)"],
          ["전체적인 CSS 통일 작업"],
          ["업무 분배 및 스케줄 조정"],
        ],
        발표영상: false,
      },
    },

    {
      title: "Limited Vocabulary KWS & Classifier for STT",
      body: {
        "프로젝트 타입": "졸업작품 (2인)",
        주제:
          "여러가지 딥러닝 구조로 음성 KWS과 30 words classifier 모델을 구축하고 학습할 수 있다. 학습된 모델을 이용하여 10초동안 녹음한 음원에서 키워드 유무를 판단하고, 존재한다면 Classifier가 작동하여 Speech to Text 결과를 출력한다.",
        "수행 기간": "2020-01 ~ 2020-10",
        포지션: "딥러닝 모델 구축 및 학습, 팀장",
        사용스택: ["python", "pytorch", "libROSA", "Deep Learning"],
        깃헙링크: "https://github.com/ddubbu/Univ-Grad-Portfolio",
        배포링크: false,
        회고록: false,
        역할: [
          ["[Dataset] Google Speech commands Dataset v0.01"],
          [
            "[Baseline] \n- KWS Task : GRU 2 layer \n- 30 words Classifier Task : 3 Block Resnet",
          ],
          [
            "[Training Result] \n- KWS Task : (F1-score, test) 0.691 \n- 30 words Classifier Task : (Accuracy, test) 89.778",
          ],
        ],
        발표영상: "https://www.youtube.com/embed/mAukIRp3yaU",
      },
    },
    {
      title: "5G 시대의 편리한 IoT 쇼핑 환경 개발",
      body: {
        "프로젝트 타입": "5인 프로젝트",
        주제: "카메라, RFID 입력값에 따른 Customizing 전자가격표시기(ESL) 개발",
        "수행 기간": "2019-04 ~ 2019-11",
        포지션: "HW 펌웨어 개발",
        사용스택: ["C", "Arduino", "AWS(Lambda, API Gateway)"],
        깃헙링크: "https://github.com/ddubbu/Hanium-2019-Dice-IoT",
        배포링크: false,
        회고록: false,
        역할: [
          [
            "HW + 펌웨어 개발 \n- ESP8266 외 HW(스피커, E-Paper, RFID) Library 응용 \n- 펌웨어 소스코드 관리(디버깅, 모듈화)",
          ],
        ],
        발표영상: "https://www.youtube.com/embed/ScoGrzJ7GkQ",
      },
    },
    {
      title: "게시판 관리 전용 웹 개발",
      body: {
        "프로젝트 타입": "3인 프로젝트",
        주제:
          "전자게시판(사이니지) 개인화 촉구 및 게시판 통합 관리 편리성 제공",
        "수행 기간": "2018-04 ~ 2018-11",
        포지션: "Back-end, 팀장",
        사용스택: ["AngularJS", "Node.js", "Express", "SQLite"],
        깃헙링크: "https://github.com/ddubbu/Hanium-2018-Dachshund",
        배포링크: false,
        회고록: false,
        역할: [
          ["팀장 \n업무 분담, code 관리, 스케줄 조정, 결과 보고서 작성"],
          ["서버 개발 \n- RESTful API 설계\n- controller.js 개발"],
        ],
        발표영상: "https://www.youtube.com/embed/ldDju9OLW0U",
      },
    },
  ];

  const [show, setShow] = useState(false);
  const [contentN, setContentN] = useState(0);

  const handleClose = () => setShow(false);
  const handleShow = (e, num) => {
    setShow(true);
    setContentN(num);
  };

  // section id="work" styling 말고 navToggler 를 위해서
  return (
    <>
      {/* <Button variant="primary" onClick={handleShow}>
        Launch demo modal
      </Button> */}

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{modalContent[contentN].title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <article class="card-portfolio-item">
            <div class="section-items-group">
              <div class="card-resume-detail-item">
                <div class="card-text card-period">프로젝트타입</div>
                <div class="card-body">
                  <h5 class="card-text">
                    {modalContent[contentN].body["프로젝트 타입"]}
                  </h5>
                </div>
              </div>
              <div class="card-resume-detail-item">
                <div class="card-text card-period">주제</div>
                <div class="card-body">
                  <h5 class="card-text">
                    {modalContent[contentN].body["주제"]}
                  </h5>
                </div>
              </div>
              <div class="card-resume-detail-item">
                <div class="card-text card-period">수행 기간</div>
                <div class="card-body">
                  <h5 class="card-text">
                    {modalContent[contentN].body["수행 기간"]}
                  </h5>
                </div>
              </div>
              <div class="card-resume-detail-item">
                <div class="card-text card-period">포지션</div>
                <div class="card-body">
                  <h5 class="card-text">
                    {modalContent[contentN].body["포지션"]}
                  </h5>
                </div>
              </div>
              <div class="card-resume-detail-item">
                <div class="card-text card-period">사용스택</div>
                <div class="card-body">
                  <p class="card-text description">
                    {modalContent[contentN].body["사용스택"].map((stack) => {
                      return <span>{stack}</span>;
                    })}
                  </p>
                </div>
              </div>
              <div class="card-resume-detail-item">
                <div class="card-text card-period">깃헙링크</div>
                <div class="card-body">
                  <a href={modalContent[contentN].body["깃헙링크"]}>
                    <h5 class="card-text">바로가기</h5>{" "}
                  </a>
                </div>
              </div>
              {modalContent[contentN].body["배포링크"] ? (
                <div class="card-resume-detail-item">
                  <div class="card-text card-period">배포링크</div>
                  <div class="card-body">
                    <a href={modalContent[contentN].body["배포링크"]}>
                      <h5 class="card-text">바로가기</h5>
                    </a>
                  </div>
                </div>
              ) : null}
              {modalContent[contentN].body["회고록"] ? (
                <div class="card-resume-detail-item">
                  <div class="card-text card-period">회고록</div>

                  <div class="card-body">
                    <a href={modalContent[contentN].body["회고록"]}>
                      <h5 class="card-text">바로가기</h5>
                    </a>
                  </div>
                </div>
              ) : null}
              <div class="card-resume-detail-item">
                <div class="card-text card-period">역할</div>
                <div class="card-body">
                  <ol>
                    {modalContent[contentN].body["역할"].map((ele) => {
                      return (
                        <>
                          <li>{ele[0]}</li>
                        </>
                      );
                    })}
                  </ol>
                  {/* <p class="card-text description">
                    [직군 관련 이수 과목]
                    <br />
                    <span>C언어</span>
                    자료 구조론, 알고리즘, 컴퓨터 네트워크
                    <br />
                    <span>Python</span>
                    공학도를 위한 창의적 컴퓨팅, 공학도를 위한 창의적
                    프로그래밍, 선형대수, 인공지능개론
                    <br />
                    <span>신호처리</span>
                    디지털 논리설계, 확률 통계론, 수치해석 (MATLAB), 랜덤
                    프로세스
                  </p> */}
                </div>
              </div>
              {modalContent[contentN].body["발표영상"] ? (
                <div class="card-resume-detail-item">
                  <div class="card-text card-period">발표 영상</div>
                  <div class="card-body">
                    <iframe
                      src={modalContent[contentN].body["발표영상"]}
                      hidden={false}
                      width="100%"
                      height="400px"
                    ></iframe>
                  </div>
                </div>
              ) : null}
            </div>
          </article>
        </Modal.Body>
      </Modal>

      <section id="work" className="portfolio-mf sect-pt4 route">
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <div className="title-box text-center">
                <h3 className="title-a">Works</h3>
                {/* <p className="subtitle-a">
                  Main Stack : React, Node.js, Express, python, pytorch, C
                </p> */}
                <div className="line-mf"></div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6" onClick={(e) => handleShow(e, 0)}>
              <div className="work-box">
                <div className="work-img">
                  <img src={drms1} alt="" className="img-fluid" />
                </div>
                <div className="work-content">
                  <div className="row">
                    <div className="col-sm-12">
                      <h2 className="w-title">재난 대응 플랫폼</h2>
                      <div className="w-more">
                        <span className="w-ctegory">
                          지도 및 실시간 데이터 시각화, NoSQL data modeling
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6" onClick={(e) => handleShow(e, 1)}>
              <div className="work-box">
                <div className="work-img">
                  <img src={eton1} alt="" className="img-fluid" />
                </div>
                <div className="work-content">
                  <div className="row">
                    <div className="col-sm-12">
                      <h2 className="w-title">Trello 클론 프로젝트</h2>
                      <div className="w-more">
                        <span className="w-ctegory">
                          Drag & Drop 기능 구현 및 전체적인 CSS 통일
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6" onClick={(e) => handleShow(e, 2)}>
              <div className="work-box">
                <div className="work-img">
                  <img src={졸작1} alt="" className="img-fluid" />
                </div>
                <div className="work-content">
                  <div className="row">
                    <div className="col-sm-12">
                      <h2 className="w-title">30 words classifier</h2>
                      <div className="w-more">
                        <span className="w-ctegory">
                          딥러닝 모델 구축 및 학습 (GRU, Resnet)
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6" onClick={(e) => handleShow(e, 3)}>
              <div className="work-box">
                <div className="work-img">
                  <img src={dice1} alt="" className="img-fluid" />
                </div>
                <div className="work-content">
                  <div className="row">
                    <div className="col-sm-12">
                      <h2 className="w-title">전자가격표시기</h2>
                      <div className="w-more">
                        <span className="w-ctegory">
                          2019 한이음 | 펌웨어 개발 - ESP8266 외 HW(스피커, E-Paper, RFID)
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6" onClick={(e) => handleShow(e, 4)}>
              <div className="work-box">
                <div className="work-img">
                  <img src={raseye1} alt="" className="img-fluid" />
                </div>
                <div className="work-content">
                  <div className="row">
                    <div className="col-sm-12">
                      <h2 className="w-title">전자게시판 관리 웹페이지</h2>
                      <div className="w-more">
                        <span className="w-ctegory">2018 한이음 | Restful API 설계 및 controller 개발</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Portfolio;
